import { Box, Image } from '@chakra-ui/react';
import { ASSETS } from '../assets';

interface PhoneProps {
  screenshot: string;
}

export const Phone = ({ screenshot }: PhoneProps) => {
  return (
    <Box position="relative" height="600px" width="300px" mx={2}>
      <Box
        position="absolute"
        overflow="hidden"
        borderTopEndRadius={'70px'}
        borderTopStartRadius={'48px'}
        borderBottomEndRadius={'70px'}
        borderBottomStartRadius={'48px'}
        top={2}
        bottom={-3}
        right={-1}
        left={3}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <Image src={screenshot} height="100%" width="95%" objectFit="cover" />
      </Box>
      <Image
        src={ASSETS.images.iPhone17ProMax}
        position="absolute"
        top="0"
        left="0"
        zIndex={2}
        pointerEvents="none"
      />
    </Box>
  );
};
